// RedirectHandler.tsx

import { useUserRedirect } from 'hooks/useUserRedirect';

import { useEffect } from 'react';

const RedirectHandler = () => {
  const { redirectToLandingPage, initializeSessionFromStorage } = useUserRedirect();

  useEffect(() => {
    initializeSessionFromStorage();
     redirectToLandingPage();
  }, []);

  return null; // or a loader/spinner
};

export default RedirectHandler;
